import template from './locations.html';
import controller from './locations.controller';
import './locations.scss';

let locationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default locationsComponent;
